/**
 * Keyboard shortcuts — single source for handlers and button tooltips.
 * Format: tooltip = "Label (K)" where K is the key.
 */
export const shortcuts = {
  newGame: { key: 'n', label: 'New' },
  undo: { key: 'z', label: 'Undo' },
  redo: { key: 'y', label: 'Redo' },
  flip: { key: 'f', label: 'Flip' },
  creator: { key: 'c', label: 'Creator mode' },
  deselect: { key: 'Escape', label: 'Deselect' },
} as const;

export function shortcutTitle(
  id: keyof typeof shortcuts,
  extra?: string,
): string {
  const s = shortcuts[id];
  const key =
    s.key === 'Escape' ? 'Esc' : s.key.length === 1 ? s.key.toUpperCase() : s.key;
  const base = `${s.label} (${key})`;
  return extra ? `${base} — ${extra}` : base;
}
